export default function SectionAbout() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap mb-3">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              7777影院 — 为热爱影视的你而生
            </h2>
            <div className="space-y-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                7777影院成立于2018年，是国内领先的免费在线视频平台之一。我们致力于为每一位影视爱好者提供最便捷、最高清的观影体验，让好内容触手可及。
              </p>
              <p>
                平台已收录超过<strong className="text-primary-600 font-semibold">10万部</strong>影片资源，涵盖动作、喜剧、科幻、悬疑、文艺、动画等<strong className="text-primary-600 font-semibold">30多个</strong>细分品类。从奥斯卡获奖影片到小众独立佳作，从经典港片到日韩热剧，你总能在这里找到想看的。
              </p>
              <p>
                团队核心成员来自国内一线视频平台与互联网大厂，拥有丰富的内容运营与技术研发经验。我们持续优化视频引擎与推荐算法，确保每日<strong className="text-primary-600 font-semibold">200+部</strong>更新内容第一时间送达你的屏幕。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-team-line text-primary-600 text-sm"></i>
                </div>
                <span className="text-foreground-700 text-sm">专业团队运营</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-server-line text-accent-700 text-sm"></i>
                </div>
                <span className="text-foreground-700 text-sm">全球CDN加速</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-shield-star-line text-secondary-700 text-sm"></i>
                </div>
                <span className="text-foreground-700 text-sm">安全纯净观影</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[5/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20streaming%20platform%20concept%20art%20with%20floating%20cinematic%20movie%20posters%20in%20dark%20space%2C%20warm%20red%20and%20golden%20neon%20accents%2C%20clean%20futuristic%20interface%20elements%2C%20professional%20branding%20visual%2C%20minimal%20sleek%20design&width=1000&height=600&seq=about-main-7777-v2&orientation=landscape"
                alt="7777影院品牌形象 - 现代数字影视平台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}